import styled from "styled-components";

const fontSize = size => {
  if (size === "s") {
    return "0.75rem";
  }
  if (size === "m") {
    return "1.1rem";
  }
  if (size === "l") {
    return "1.25rem";
  }
  return "1rem";
};

const P = styled.p`
  margin: 0 0 1.5rem 0;
  font-family: ${props =>
    ["urban", "veilance"].includes(props.market.toLowerCase())
      ? '"Suisse Intl Regular", arial, sans-serif'
      : '"urw-din", arial, sans-serif'};
  font-size: ${props => fontSize(props.size)};
  font-weight: ${props => (props.bold ? `600` : `400`)};
  font-style: ${props => (props.italic ? `italic` : `normal`)};
  line-height: ${props => (props.size === "s" ? `1rem` : `1.5rem`)};
  color: ${props => props.textColor};
  text-decoration: ${props => props.textDecoration};

  strong,
  b {
    font-weight: 500;
  }

  em,
  i {
    font-weight: 400;
    font-style: italic;
  }

  &:last-of-type {
    margin-bottom: 0;
  }
`;

P.defaultProps = {
  large: false,
  textColor: "var(--colour-copy)",
  textDecoration: "none",
  market: "outdoor",
};
export default P;
